"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const colorDiff = 120;
const shallowCloneArr = function () {
  let arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let cntr = arr.length;
  const clone = new Array(arr.length);
  cntr -= 1;
  while (cntr >= 0) {
    clone[cntr] = arr[cntr];
    cntr -= 1;
  }
  return clone;
};
const shallowClone = v => {
  if (v instanceof Array) {
    return shallowCloneArr(v);
  }
  if (typeof v !== 'object') {
    return v;
  }
  const keys = Object.keys(v);
  const clone = {};
  let idx = 0;
  while (idx < keys.length) {
    clone[keys[idx]] = v[keys[idx]];
    idx += 1;
  }
  return clone;
};
const MiscUtils = {
  // Can be used for DatFiles or anything else we need
  colors: ['lime',
  // 'aqua', This is the same as the pipeline layers
  // 'salmon', This looks too similar to GPS AutoCorrected line
  'gold', 'darkorchid', 'hotpink', 'coral', 'cornflowerblue', 'crimson', 'darkgoldenrod',
  // 'purple', This is the same color as the powerline layer
  'brown', 'forestgreen', 'midnightblue', 'orangered'],
  _randomHex() {
    return (Math.floor(colorDiff * Math.random()) + (255 - colorDiff)).toString(16);
  },
  getRandomColor() {
    return `#${MiscUtils._randomHex()}${MiscUtils._randomHex()}${MiscUtils._randomHex()}`;
  },
  getColorByIndex(index) {
    return MiscUtils.colors[index];
  },
  getColorByIndexOrRandom(index, reverse) {
    const idx = !reverse ? index % MiscUtils.colors.length : MiscUtils.colors.length - 1 - index % MiscUtils.colors.length;
    const colorByIndex = MiscUtils.colors[idx];
    if (colorByIndex) {
      return colorByIndex;
    }
    return MiscUtils.getRandomColor();
  },
  checkProdOnNode() {
    const stage = process.env.STAGE;
    if (stage && stage.toLowerCase() === 'prod') {
      return true;
    }
    return false;
  },
  checkProdOnBrowser() {
    const testDomainContains = ['test', 'dev', 'local', 'beta'];
    // TODO: Obviously this won't work in node
    const isTest = testDomainContains.some(domain => window.location.hostname.indexOf(domain) > -1);
    return !isTest;
  },
  isProd() {
    try {
      return MiscUtils.checkProdOnBrowser();
    } catch {
      try {
        return MiscUtils.checkProdOnNode();
      } catch {
        return true; // Default to true if we are using somesort of headless browser
      }
    }
  },
  roundToDigitPlace(number, decimalPlaceToRound) {
    const stringWithDecimals = (number || 0).toFixed(decimalPlaceToRound);
    const roundedNumber = +stringWithDecimals;
    return roundedNumber;
  },
  shallowCopy(obj) {
    let newObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // eslint-disable-next-line prefer-object-spread
    return Object.assign({}, obj, newObj);
  }
};
var _default = MiscUtils;
exports.default = _default;